// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--lU7l1";
export var connect = "footer-module--connect--JX93x";
export var linkListCont = "footer-module--linkListCont--aSkhB";
export var listHdr = "footer-module--listHdr--taAi+";
export var linkList = "footer-module--linkList--RTrip";
export var copyright = "footer-module--copyright--Bg9Rz";
export var logoLinks = "footer-module--logoLinks--afTlG";
export var fadeIn = "footer-module--fadeIn--cTOzp";
export var slideIn = "footer-module--slideIn--ogK3N";